import { Rating } from "@mui/material";

export default function RatingField({ fieldName, fieldValue, onChange }) {
  return (
    <Rating
      value={Number(fieldValue)}
      onChange={(event, newValue) => {
        onChange(fieldName, newValue);
      }}
    />
  );
}
